module.exports = __webpack_public_path__ + "img/icon-double-story-highlight.ac9509a5.svg";